import(/* webpackMode: "eager" */ "/app/apps/insurer-app/app/error.tsx")